// extracted by mini-css-extract-plugin
module.exports = {"controlsContainer":"TransferControls_controlsContainer__1-hsW","transferButton":"TransferControls_transferButton__24QN3"};